<template>
  <div class="inquiry-order-page">
    <div class="inquiry-order-section">
      <ulu-inquiry-order-charts />
    </div>
    <div class="inquiry-order-section">
      <ulu-order-charts />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    "ulu-inquiry-order-charts": () =>
      import("@/components/dashboard/inquiry_order/InquiryOrderCharts.vue"),
    "ulu-order-charts": () =>
      import("@/components/dashboard/inquiry_order/OrderCharts.vue")
  }
};
</script>

<style scoped>
.inquiry-order-page {
  background-color: #f7f7f7;
  min-height: 100vh;
  padding: 24px;
}

.inquiry-order-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
  overflow: hidden;
}

.inquiry-order-section:last-child {
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .inquiry-order-page {
    padding: 16px;
  }
}
</style>
